import Chip from '../Chip';

interface SourceFreshnessProps {
  status?: string;
  schedule?: string;
  lastLoadTime?: string | null;
  now?: number;
}

/** Conservative age guard, independent of scheduler login and job creation. */
export function sourceFreshness({ status, schedule, lastLoadTime, now = Date.now() }: SourceFreshnessProps) {
  if (status !== 'Active' && status !== 'Error') return null;
  const cadence = (schedule || '').toLowerCase();
  // Two full intervals allow a running refresh to finish without hiding a
  // missed cycle indefinitely. Monthly uses the longest calendar month.
  const hours = cadence.includes('hourly') || cadence === 'hour' ? 2
    : cadence.includes('daily') || cadence === 'day' ? 48
      : cadence.includes('weekly') || cadence === 'week' ? 14 * 24
        : cadence.includes('monthly') || cadence === 'month' ? 62 * 24 : null;
  if (hours === null) return null;
  const loadedAt = lastLoadTime ? Date.parse(lastLoadTime) : NaN;
  if (!Number.isFinite(loadedAt)) return 'No successful sync recorded';
  if (loadedAt > now) return 'Sync timestamp is in the future';
  return now - loadedAt > hours * 3_600_000 ? 'Sync overdue' : null;
}

export default function SourceFreshness(props: SourceFreshnessProps) {
  const warning = sourceFreshness(props);
  if (!warning) return null;
  return (
    <div className="space-y-1">
      <Chip label={warning} tone="caution" size="sm" />
      <p className="text-xs text-text-secondary dark:text-text-dark-secondary">
        Check Job History. A running or failed job does not establish a successful refresh.
      </p>
    </div>
  );
}
